import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  addUser(model: User) {
    return this.http.post(`${environment.baseUrl}/api/account/create`, model, { observe: 'response' });
  }
  updateUser(model: User) {
    return this.http.post(`${environment.baseUrl}/api/account/update`, model, { observe: 'response' });
  }
  getUsers() {
    return this.http.get(`${environment.baseUrl}/api/account/get-users`, { observe: 'response' });
  }
  getRoles() {
    return this.http.get(`${environment.baseUrl}/api/account/get-roles`, { observe: 'response' });
  }
  deleteUser(id) {
    return this.http.delete(`${environment.baseUrl}/api/account/${id}`, { observe: 'response' });
  }
  passResetUser(data) {
    return this.http.post(`${environment.baseUrl}/api/account/reset-password`, data, { observe: 'response' });
  }
}
